import api from '../api'

export const insert = async (otherAccountDoms, locationId, isBillTo) => {
	for (const otherAccount of otherAccountDoms) {
		if (otherAccount.isCreate) {
			await api.service('otherAccounts').create({
				name: otherAccount.otherSupplier,
				accountNumber: otherAccount.otherAccountNumber,
				otherAccountTypeId: otherAccount.otherType,
				locationId: locationId
			})
		} else if (otherAccount.isDelete) {
			await api.service('otherAccounts').remove(null, {
				query: {
					id: {
						$eq: otherAccount.id
					}
				}
			})
		} else if (otherAccount.isUpdate) {
			await api.service('otherAccounts').patch(otherAccount.id, {
				name: otherAccount.otherSupplier,
				accountNumber: otherAccount.otherAccountNumber,
				otherAccountTypeId: otherAccount.otherType,
				locationId: locationId
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/database/otherAccounts.js